import $ from 'jquery';

module.exports = (App) => {
  App.channel.on('load:delayed:scripts', async () => {
    const configs = $('[data-bootstrap="configs"]');
    if (configs.length) {
      const parsedConfigs = JSON.parse(configs.html());
      const { assetHost } = parsedConfigs.header;
      const stylesheets = [`${assetHost}/page/header-footer-wgl/latest/css/header-footer-wgl.csg.css`,
        `${assetHost}/page/header-footer-wgl/latest/css/header-footer-wgl.mcom-header-footer.css`];
      const scripts = [`${assetHost}/page/header-footer-wgl/latest/js/common.bundle.js`,
        `${assetHost}/page/header-footer-wgl/latest/js/header-footer-wgl.mcom-header-footer.js`];
      App.channel.trigger('loading:delayed:scripts', scripts, stylesheets);
      try {
        App.channel.trigger('loaded:delayed:scripts');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Failed to load header/footer: ${e}`);
      }
      App.channel.trigger('load:tealium-scripts:async', parsedConfigs.brand, parsedConfigs.TAG_MNGR_ENV, parsedConfigs.lazyLoadTealiumEnabled);
    } else {
      App.channel.trigger('loading:delayed:scripts:failure');
    }
  });
  return App;
};
